import { Model_InvoiceLineGet } from "src/backend/openapi/v1";

export type InvoiceHistoryData = {
  id: string;
  date: string;
  invoiceNumber: string;
  orderNumber: string;
  project: string;
  dueBalance: string;
  contactPerson: string;
  document: string;
};

export type FormType = {
  wildcardSearch: string | null;
  fromDate: Date | null;
  toDate: Date | null;
};

export type InvoiceLineGet = Pick<
  Model_InvoiceLineGet,
  "linePriceExVAT" | "description" | "description2" | "navInvoiceId" | "navInvoiceLineId" | "productDescription" | "productId" | "productNumber" | "quantity" | "lineNo" | "unitPriceExVAT"
>;

export type InvoiceLinesDialogState = { selectedInvoiceId: string };

export const QUERY_PARAMS = {
  FROM_DATE: "fromDate",
  TO_DATE: "toDate",
  WILD_CARD_SEARCH: "wildCardSearch",
  PAGE: "page",
  PAGE_SIZE: "pageSize",
  INVOICE_ID: "invoiceId"
} as const;

export type TQueryParamsValues = (typeof QUERY_PARAMS)[keyof typeof QUERY_PARAMS];
